import { z } from "zod";

// SPEC-214 §8: mensaje literal `UNASSIGNED` — este es el respaldo cliente
// para el caso trivial (nadie seleccionado en el modal de asignación),
// mismo criterio que `CATEGORY_REQUIRED_MESSAGE` en offers/offerSchemas.ts.
// El caso real de negocio (contactar sin responsable ya persistido) lo
// valida el servidor; el cliente no lo puede anticipar.
export const ASSIGN_REQUIRED_MESSAGE = "Selecciona un responsable";

export const assignRequestSchema = z.object({
  assignedTo: z.string().trim().min(1, ASSIGN_REQUIRED_MESSAGE),
});
export type AssignRequestFormValues = z.infer<typeof assignRequestSchema>;

// SPEC-214 §5: la nota de cierre es obligatoria (QA-MTZ-002 ronda 2 #7,
// decisión humana 2026-09-24). Mismo texto que el rechazo de la API
// (`request.service.ts`, `CLOSE_NOTE_REQUIRED_MESSAGE`).
export const CLOSE_NOTE_REQUIRED_MESSAGE =
  "Escribe una nota para cerrar la solicitud.";

export const closeRequestSchema = z.object({
  note: z.string().trim().min(1, CLOSE_NOTE_REQUIRED_MESSAGE),
});
export type CloseRequestFormValues = z.infer<typeof closeRequestSchema>;
